/* lib/impersonate.js — superadmin "log in as this dealer" (2026-09-07).
 * The admin's own token is parked under lhc_admin_token, the target's
 * impersonation token becomes the session, and the app reloads into the
 * dealer's home route — no password involved. endImpersonation() restores. */
import axios from "axios";
import { clearCatalogMirror } from "@/lib/catalogMirror";

const API = `${process.env.REACT_APP_BACKEND_URL || ""}/api`;
export const ADMIN_TOKEN_KEY = "lhc_admin_token";
const TOKEN_KEY = "lhc_token";

export async function impersonate(userId) {
  const { data } = await axios.post(`${API}/admin/impersonate/${userId}`);
  const current = localStorage.getItem(TOKEN_KEY);
  if (current && !localStorage.getItem(ADMIN_TOKEN_KEY)) localStorage.setItem(ADMIN_TOKEN_KEY, current);
  clearCatalogMirror();
  localStorage.setItem(TOKEN_KEY, data.token);
  window.location.assign((data.user && data.user.default_route) || "/store");
  return data;
}

export function endImpersonation() {
  const admin = localStorage.getItem(ADMIN_TOKEN_KEY);
  clearCatalogMirror();
  if (admin) localStorage.setItem(TOKEN_KEY, admin); else localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(ADMIN_TOKEN_KEY);
  window.location.assign(admin ? "/admin" : "/partners/login");
}
